import {GameClientUserState} from '@colonist/game-base-types'
import React, {createContext, useContext} from 'react'

const UIGameUserStatesContext = createContext<GameClientUserState[]>([])

export function UIGameUserStatesProvider({
    children,
    userStates,
}: {
    children: React.ReactNode
    userStates: GameClientUserState[]
}) {
    return (
        <UIGameUserStatesContext.Provider value={userStates}>
            {children}
        </UIGameUserStatesContext.Provider>
    )
}

export function useUIGameUserStatesContext() {
    return useContext(UIGameUserStatesContext)
}
